import { useMedia } from 'react-use';
import variables from '@appclose/ui/src/scss/_export.module.scss';

export default function useIsMobileDevice(
  breakpoint = parseInt(variables.breakpointDesktop, 10)
) {
  return useMedia(`(max-width: ${breakpoint - 1}px)`);
}
